import { ca } from '@cian/analytics';

interface IParameters {
  name: string;
  query: string;
  suggestPos: string;
  totalSuggest: string;
  href: string;
  suggestType: string;
  isDuplicateSuggest: boolean;
}

export function trackSuggestClick({
  name,
  query,
  suggestPos,
  totalSuggest,
  href,
  suggestType,
  isDuplicateSuggest,
}: IParameters) {
  ca('eventSite', {
    name: 'oldevent',
    action: 'click',
    category: 'search_string',
    label: href,
    page: {
      extra: {
        clickType: 'search_suggest',
        searchQuery: query,
        suggestName: name,
        suggestPosition: suggestPos,
        suggestCount: totalSuggest,
        suggestType,
        isDuplicateSuggest: isDuplicateSuggest.toString(),
      },
    },
  });
}
